import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Check } from 'lucide-react';
const steps = [{
  label: 'Profile',
  path: '/profile'
}, {
  label: 'Results',
  path: '/results'
}, {
  label: 'Plan',
  path: '/plan'
}, {
  label: 'Review',
  path: '/review'
}];
export function Stepper() {
  const {
    pathname
  } = useLocation();
  const current = pathname === '/confirmed' ? steps.length : steps.findIndex(s => s.path === pathname);
  if (current === -1) return <div aria-hidden="true" data-id="element-157" data-mp="1l50yj1wy347c" />;
  return <nav aria-label="Progress" data-id="element-158" data-mp="1l628t464zmo0">
      <p className="font-mono text-xs text-muted-foreground md:hidden" data-id="element-159" data-mp="1l5anqna617bz">
        {current >= steps.length ? 'Order placed' : `Step ${current + 1} of ${steps.length}`}
      </p>
      <ol className="hidden items-center gap-2 md:flex" data-id="element-160" data-mp="1u6ib4ab58nra">
        {steps.map((step, i) => {
        const done = i < current;
        const active = i === current;
        const content = <span className={`flex items-center gap-2 rounded-full px-3 py-1.5 text-sm transition-colors ${active ? 'bg-white/10 text-foreground' : done ? 'text-foreground hover:bg-white/5' : 'text-muted-foreground'}`} data-id="element-161" data-mp="35jkqj21ib79v">
              <span className={`flex size-5 items-center justify-center rounded-full font-mono text-[10px] ${done ? 'bg-[#9b8cf0] text-[#0f1017]' : active ? 'border border-[#9b8cf0] text-[#c4baff]' : 'border border-white/15'}`} data-id="element-162" data-mp="3qwll429sb7kc">
                {done ? <Check className="size-3" data-id="element-163" data-mp="3d4ypm4no232m" /> : i + 1}
              </span>
              {step.label}
            </span>;
        return <li key={step.path} className="flex items-center gap-2" aria-current={active ? 'step' : undefined} data-id="element-164" data-mp="384kg0i6f2l2h" data-mpi={i}>
              {done && current < steps.length ? <Link to={step.path} data-id="element-165" data-mp="2y7o4s4p4vku8">{content}</Link> : content}
              {i < steps.length - 1 && <span className="h-px w-4 bg-white/15" aria-hidden="true" data-id="element-166" data-mp="2u6vvjbg9hfxy" />}
            </li>;
      })}
      </ol>
    </nav>;
}